import { createRequest } from "helpers/tools";

export const downloadPdf = async (id) => {
    return await createRequest({
        suffix: `trackers/reports/${id}/download-pdf`,
        method: "get",
        handleError: false,
    });
};
